import { ReactNode } from 'react';

import { ErrorBoundary } from './ErrorBoundary.jsx';

/**
 * RTKQueryErrorResetBoundary is a React Component that resets the error state of a RTK Query when the user navigates away from a page or component.
 * It is useful for when a query fails and you want to reset its error state automatically when the user navigates to a different page or component.
 * It also sends these errors to Datadog Real User Monitoring (RUM) for further analysis.
 *
 * @component
 *
 * @param children - The child components that the RTKQueryErrorResetBoundary will encapsulate.
 * @param scope - The scope in which the RTKQueryErrorResetBoundary is used, default is 'rtk-query-error-boundary'. This is used to categorize the errors in Datadog.
 *
 * @example
 * <RTKQueryErrorResetBoundary scope="homepage">
 *   <Homepage />
 * </RTKQueryErrorResetBoundary>
 */
export const RTKQueryErrorResetBoundary = ({
  children,
  scope = 'rtk-query-error-boundary',
}: {
  children: ReactNode;
  scope?: string;
}) => {
  const reset = () => {
    globalThis.location.reload();
  };

  return (
    <ErrorBoundary scope={scope} onReset={reset}>
      {children}
    </ErrorBoundary>
  );
};
